import Typography, { ITypographyProps } from 'component/commonComponents/Typography';
import * as React from 'react';
import { StyledUserInfo } from './userInfo.style';

export interface IUserInfoProps {
  label?: string;
  data?: any;
  hideLabel?: boolean;
  disableShadow?: boolean;
  isRequestVM?: boolean;
  isRequestVA?: boolean;
  style?: any & {
    labelStyle?: ITypographyProps;
  };
  locale?: any;
}

const UserInfo: React.FC<IUserInfoProps> = (props) => {
  const { label, data, hideLabel, disableShadow, isRequestVM, isRequestVA, style = {}, locale } = props;
  const { labelStyle = {}, ...wrapperStyle } = style;

  return (
    <StyledUserInfo disableShadow={disableShadow} sx={wrapperStyle}>
      {!hideLabel && (
        <Typography className="component-label" {...labelStyle}>
          {label || locale?.label}
        </Typography>
      )}
      <div className="info">
        <div className="row">
          <span className="label">{locale?.firstName}: </span>
          <span className="value">{data?.first_name}</span>
        </div>
        <div className="row">
          <span className="label">{locale?.lastName}: </span>
          <span className="value">{data?.last_name}</span>
        </div>
        <div className="row">
          <span className="label">{locale?.emailAddress}: </span>
          <span className="value">{data?.email}</span>
        </div>
        <div className="row">
          <span className="label">{locale?.employeeType}: </span>
          <span className="value">{data?.employee_type}</span>
        </div>
        {(data?.starting_date && data?.manager_email) &&
          <>
            <div className="row">
              <span className="label">{locale?.startingDate}: </span>
              <span className="value">{data?.starting_date}</span>
            </div>
            <div className="row">
              <span className="label">{locale?.manager_email}: </span>
              <span className="value">{data?.manager_email}</span>
            </div>
          </>
        }
        {data?.personal_email && 
          <div className="row">
            <span className="label">{locale?.personalEmail}: </span>
            <span className="value">{data?.personal_email}</span>
          </div>
        }
        {isRequestVM && (
          <>
            <div className="row">
              <span className="label">{locale?.virtualMachine}: </span>
              <span className="value">{data?.virtual_machine}</span>
            </div>
            <div className="row">
              <span className="label">{locale?.comment}: </span>
              <span className="value">{data?.comment}</span>
            </div>
          </>
        )}
        {isRequestVA && (
          <>
            <div className="row">
              <span className="label">{locale?.virtualApp}: </span>
              <span className="value">{data?.virtual_app}</span>
            </div>
            <div className="row">
              <span className="label">{locale?.comment}: </span>
              <span className="value">{data?.comment}</span>
            </div>
          </>
        )}
      </div>
    </StyledUserInfo>
  );
};

export const defaultProps = {
  data: {},
  hideLabel: false,
  disableShadow: false,
  isRequestVM: false,
  style: {},
  locale: {
    label: 'Requested For',
    firstName: 'First Name',
    lastName: 'Last Name',
    emailAddress: 'Email Address',
    employeeType: 'Employee Type',
    virtualMachine: 'Virtual Machine',
    comment: 'Comment',
  },
};
UserInfo.defaultProps = defaultProps;

export default UserInfo;
